import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';

import {
  AuthenticationService,
  RoutesService,
  UserBeanService,
  i18nService,
} from '@services';
import { removeFalsyValueProperties } from '@shared/utils';

export const appResolver: ResolveFn<void> = async () => {
  const authenticationService = inject(AuthenticationService);
  const routesService = inject(RoutesService);
  const userBeanService = inject(UserBeanService);
  const agorai18nService = inject(i18nService);
  const router = inject(Router);

  const lastUrlParams = removeFalsyValueProperties(
    routesService.getPreviousRouteQueryParams()
  );
  const urlParams = Object.keys(lastUrlParams).length
    ? { ...lastUrlParams }
    : null;

  authenticationService.getSystemSettings().then((settings) => {
    agorai18nService.getLocale(settings);
  });

  try {
    await userBeanService.getUserBean();

    return new RedirectCommand(
      router.parseUrl(routesService.getPostAuthRedirect())
    );
  } catch {
    return new RedirectCommand(
      router.createUrlTree(['/login'], { queryParams: urlParams })
    );
  }
};
